/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import './common';
import '../../../v1/credit_card_client_driven_flow';
import '../../glyph/glyph_icon';
import '../../component/rich_text';
import '../../component/card_customization';
import '../../../../common/location';
import '../../component/component';
import '../../../../common/currency';
import '../../../v1/flow';
import '../screens/digital_wallet_configuration';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "UiElement": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "viewLogEvent": {
                        "type": ".squareup.bbfrontend.service.v1.LogEvent",
                        "id": 2,
                        "rule": "optional"
                      },
                      "buttonElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.ButtonElement",
                        "id": 3
                      },
                      "textElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.TextElement",
                        "id": 4
                      },
                      "textInputElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.TextInputElement",
                        "id": 5
                      },
                      "loadingElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.LoadingElement",
                        "id": 6
                      },
                      "spacingElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.SpacingElement",
                        "id": 7
                      },
                      "rowElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement",
                        "id": 8
                      },
                      "debitCardElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.DebitCardElement",
                        "id": 9
                      },
                      "bannerElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.BannerElement",
                        "id": 10
                      },
                      "dividerElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.DividerElement",
                        "id": 11
                      },
                      "imageElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.ImageElement",
                        "id": 12
                      },
                      "addressInputElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.AddressInputElement",
                        "id": 13
                      },
                      "cardElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement",
                        "id": 14
                      },
                      "pillElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.PillElement",
                        "id": 15
                      },
                      "moneyInputElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.MoneyInputElement",
                        "id": 16
                      },
                      "sectionHeaderElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.SectionHeaderElement",
                        "id": 17
                      },
                      "textLinkElement": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.TextLinkElement",
                        "id": 18
                      }
                    },
                    "nested": {
                      "ButtonElement": {
                        "fields": {
                          "buttonText": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "style": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.ButtonElement.Style",
                            "id": 2,
                            "rule": "optional"
                          },
                          "actionLogEvent": {
                            "type": ".squareup.bbfrontend.service.v1.LogEvent",
                            "id": 5,
                            "rule": "optional"
                          },
                          "isEnabled": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "submissionAction": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.ButtonElement.SubmissionAction",
                            "id": 3
                          },
                          "completionAction": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.ButtonElement.CompletionAction",
                            "id": 4
                          },
                          "urlAction": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.ButtonElement.UrlAction",
                            "id": 6
                          },
                          "targetFlow": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.ButtonElement.TargetFlow",
                            "id": 8
                          }
                        },
                        "nested": {
                          "SubmissionAction": {
                            "fields": {
                              "id": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "isSelected": {
                                "type": "bool",
                                "id": 2,
                                "rule": "optional",
                                "options": {
                                  "default": false
                                }
                              },
                              "loadingElement": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.LoadingElement",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          },
                          "CompletionAction": {
                            "fields": {
                              "id": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "result": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.ButtonElement.CompletionAction.Result",
                                "id": 2,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "Result": {
                                "values": {
                                  "DO_NOT_USE": 0,
                                  "SUCCESS": 1,
                                  "FAILURE": 2
                                }
                              }
                            }
                          },
                          "UrlAction": {
                            "fields": {
                              "id": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "urlString": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "useSessionBridge": {
                                "type": "bool",
                                "id": 3,
                                "rule": "optional",
                                "options": {
                                  "default": false
                                }
                              }
                            }
                          },
                          "TargetFlow": {
                            "fields": {
                              "creditCard": {
                                "type": ".squareup.bbfrontend.service.v1.CreditCardClientDrivenFlow",
                                "id": 1
                              }
                            },
                            "nested": {
                              "flow": {
                                "oneof": ["creditCard"]
                              }
                            }
                          },
                          "Style": {
                            "values": {
                              "DO_NOT_USE": 0,
                              "PRIMARY": 1,
                              "SECONDARY": 2,
                              "LINK": 3
                            }
                          },
                          "action": {
                            "oneof": ["submissionAction", "completionAction", "urlAction", "targetFlow"]
                          }
                        }
                      },
                      "TextElement": {
                        "fields": {
                          "text": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "textStyle": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.TextStyle",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": "PARAGRAPH_30"
                            }
                          },
                          "textColor": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.TextColor",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": "TEXT_10"
                            }
                          },
                          "textAlignment": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.TextAlignment",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": "TEXT_ALIGNMENT_NATURAL"
                            }
                          }
                        }
                      },
                      "TextStyle": {
                        "values": {
                          "TEXT_STYLE_DO_NOT_USE": 0,
                          "DISPLAY_10": 1,
                          "HEADING_5": 2,
                          "HEADING_10": 3,
                          "HEADING_20": 4,
                          "HEADING_30": 5,
                          "PARAGRAPH_10": 6,
                          "PARAGRAPH_20": 7,
                          "PARAGRAPH_30": 8,
                          "SEMIBOLD_10": 9,
                          "SEMIBOLD_20": 10,
                          "SEMIBOLD_30": 11,
                          "DISPLAY_20": 12
                        }
                      },
                      "TextColor": {
                        "values": {
                          "TEXT_COLOR_DO_NOT_USE": 0,
                          "TEXT_10": 1,
                          "TEXT_20": 2,
                          "TEXT_30": 3,
                          "EMPHASIS": 4,
                          "SUCCESS": 5,
                          "WARNING": 6,
                          "CRITICAL": 7
                        }
                      },
                      "TextAlignment": {
                        "values": {
                          "TEXT_ALIGNMENT_NATURAL": 0,
                          "TEXT_ALIGNMENT_CENTER": 1
                        }
                      },
                      "TextInputElement": {
                        "fields": {
                          "label": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "placeholder": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "value": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": ""
                            }
                          },
                          "helperMessage": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.TextInputElement.HelperMessage",
                            "id": 4,
                            "rule": "optional"
                          },
                          "isEditable": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "validation": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.TextInputElement.TextValidation",
                            "id": 6,
                            "rule": "optional"
                          },
                          "keyboardType": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.TextInputElement.KeyboardType",
                            "id": 7,
                            "rule": "optional",
                            "options": {
                              "default": "DEFAULT"
                            }
                          }
                        },
                        "nested": {
                          "HelperMessage": {
                            "fields": {
                              "hint": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "error": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "TextValidation": {
                            "fields": {
                              "regex": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "template": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.TextInputElement.TextValidation.Template",
                                "id": 2,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "Template": {
                                "fields": {
                                  "template": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "templatePlaceholderCharacter": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "userInsertableFormatCharacters": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          },
                          "KeyboardType": {
                            "values": {
                              "KEYBOARD_TYPE_DO_NOT_USE": 0,
                              "DEFAULT": 1,
                              "NUMPAD": 2,
                              "PHONE": 3,
                              "EMAIL": 4,
                              "DATE": 5
                            }
                          }
                        }
                      },
                      "LoadingElement": {
                        "fields": {
                          "activityIndicatorSize": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.LoadingElement.ActivityIndicatorSize",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": "LARGE"
                            }
                          },
                          "title": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "subtitle": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "ActivityIndicatorSize": {
                            "values": {
                              "DO_NOT_USE": 0,
                              "LARGE": 1,
                              "SMALL": 2
                            }
                          }
                        }
                      },
                      "SpacingElement": {
                        "fields": {
                          "size": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.SpacingElement.Size",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": "SPACING_100"
                            }
                          }
                        },
                        "nested": {
                          "Size": {
                            "values": {
                              "DO_NOT_USE": 0,
                              "SPACING_25": 25,
                              "SPACING_100": 100,
                              "SPACING_150": 150,
                              "SPACING_200": 200,
                              "SPACING_300": 300,
                              "SPACING_400": 400,
                              "SPACING_500": 500
                            }
                          }
                        }
                      },
                      "RowElement": {
                        "fields": {
                          "style": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement.RowStyle",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": "MEDIUM"
                            }
                          },
                          "icon": {
                            "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                            "id": 2,
                            "rule": "optional"
                          },
                          "textContent": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement.TextContent",
                            "id": 3,
                            "rule": "optional"
                          },
                          "trailingAccessory": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement.TrailingAccessory",
                            "id": 4,
                            "rule": "optional"
                          },
                          "accessoryAlignment": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement.AccessoryAlignment",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": "ACCESSORY_ALIGNMENT_CENTER"
                            }
                          },
                          "isEnabled": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "isSelected": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "isSeparatorVisible": {
                            "type": "bool",
                            "id": 8,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "groupIdentifier": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "submissionLogEvent": {
                            "type": ".squareup.bbfrontend.service.v1.LogEvent",
                            "id": 10,
                            "rule": "optional"
                          },
                          "isSelectable": {
                            "type": "bool",
                            "id": 11,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "action": {
                            "type": ".squareup.bbfrontend.service.v1.PerformableAction",
                            "id": 12,
                            "rule": "optional"
                          },
                          "leadingAccessory": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement.LeadingAccessory",
                            "id": 14,
                            "rule": "optional",
                            "options": {
                              "default": "LEADING_ACCESSORY_GLYPH_ICON"
                            }
                          },
                          "trailingAccessoryTextLinkMetadata": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement.TextLinkTrailingAccessory",
                            "id": 15,
                            "rule": "optional"
                          },
                          "titleTrailingPill": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.PillElement",
                            "id": 13
                          }
                        },
                        "nested": {
                          "TextContent": {
                            "fields": {
                              "standard": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement.TextContent.Standard",
                                "id": 1
                              },
                              "custom": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement.TextContent.Custom",
                                "id": 2
                              }
                            },
                            "nested": {
                              "Standard": {
                                "fields": {
                                  "title": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "secondaryText": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "sideText": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "secondarySideText": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "styleOverrides": {
                                    "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement.TextContent.Standard.StyleOverrides",
                                    "id": 5,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "StyleOverrides": {
                                    "fields": {
                                      "titleOverride": {
                                        "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement.TextContent.Standard.StyleOverrides.Override",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "secondaryTextOverride": {
                                        "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement.TextContent.Standard.StyleOverrides.Override",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "sideTextOverride": {
                                        "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement.TextContent.Standard.StyleOverrides.Override",
                                        "id": 3,
                                        "rule": "optional"
                                      },
                                      "secondarySideTextOverride": {
                                        "type": ".squareup.bbfrontend.service.v1.UiElement.RowElement.TextContent.Standard.StyleOverrides.Override",
                                        "id": 4,
                                        "rule": "optional"
                                      }
                                    },
                                    "nested": {
                                      "Override": {
                                        "fields": {
                                          "textStyle": {
                                            "type": ".squareup.bbfrontend.service.v1.UiElement.TextStyle",
                                            "id": 1,
                                            "rule": "optional"
                                          },
                                          "textColor": {
                                            "type": ".squareup.bbfrontend.service.v1.UiElement.TextColor",
                                            "id": 2,
                                            "rule": "optional"
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              },
                              "Custom": {
                                "fields": {
                                  "primaryContent": {
                                    "type": ".squareup.bbfrontend.service.v1.UiElement.TextElement",
                                    "id": 1,
                                    "rule": "repeated"
                                  },
                                  "secondaryContent": {
                                    "type": ".squareup.bbfrontend.service.v1.UiElement.TextElement",
                                    "id": 2,
                                    "rule": "repeated"
                                  }
                                }
                              },
                              "content": {
                                "oneof": ["standard", "custom"]
                              }
                            }
                          },
                          "AccessoryAlignment": {
                            "values": {
                              "ACCESSORY_ALIGNMENT_CENTER": 0,
                              "ACCESSORY_ALIGNMENT_TOP": 1
                            }
                          },
                          "LeadingAccessory": {
                            "values": {
                              "LEADING_ACCESSORY_GLYPH_ICON": 0,
                              "LEADING_ACCESSORY_APPLE_PAY_LOGO": 1
                            }
                          },
                          "TrailingAccessory": {
                            "values": {
                              "DO_NOT_USE_TRAILING_ACCESSORY": 0,
                              "DRILL": 1,
                              "TOGGLE": 2,
                              "CHECKBOX": 3,
                              "RADIO": 4,
                              "TEXT_LINK": 5
                            }
                          },
                          "RowStyle": {
                            "values": {
                              "SMALL": 0,
                              "MEDIUM": 1
                            }
                          },
                          "TextLinkTrailingAccessory": {
                            "fields": {
                              "text": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "TitleTrailingAccessory": {
                            "oneof": ["titleTrailingPill"]
                          }
                        }
                      },
                      "SectionHeaderElement": {
                        "fields": {
                          "style": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.SectionHeaderElement.Style",
                            "id": 1,
                            "rule": "optional"
                          },
                          "title": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "paragraph": {
                            "type": ".squareup.bbfrontend.common.component.RichText",
                            "id": 3,
                            "rule": "optional"
                          },
                          "accessibilityLabel": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "titleAccessoryPill": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.PillElement",
                            "id": 5
                          },
                          "trailingAccessoryPill": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.PillElement",
                            "id": 6
                          }
                        },
                        "nested": {
                          "Style": {
                            "values": {
                              "DO_NOT_USE_SECTION_HEADER_STYLE": 0,
                              "SECTION_HEADER_STYLE_10": 1,
                              "SECTION_HEADER_STYLE_20": 2,
                              "SECTION_HEADER_STYLE_30": 3
                            }
                          },
                          "TitleAccessory": {
                            "oneof": ["titleAccessoryPill"]
                          },
                          "TrailingAccessory": {
                            "oneof": ["trailingAccessoryPill"]
                          }
                        }
                      },
                      "DebitCardElement": {
                        "fields": {
                          "isLocked": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "front": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.DebitCardElement.CardFront",
                            "id": 2
                          },
                          "back": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.DebitCardElement.CardBack",
                            "id": 3
                          }
                        },
                        "nested": {
                          "CardFront": {
                            "fields": {
                              "businessName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "customization": {
                                "type": ".squareup.bbfrontend.common.component.CardCustomization",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "CardBack": {
                            "fields": {
                              "fullName": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "obscured": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.DebitCardElement.CardBack.ObscuredCardData",
                                "id": 2
                              },
                              "private": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.DebitCardElement.CardBack.PrivateCardData",
                                "id": 3
                              }
                            },
                            "nested": {
                              "ObscuredCardData": {
                                "fields": {
                                  "panLastFour": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "PrivateCardData": {
                                "fields": {
                                  "pan": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "expiration": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "securityCode": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "card_data": {
                                "oneof": ["obscured", "private"]
                              }
                            }
                          },
                          "side": {
                            "oneof": ["front", "back"]
                          }
                        }
                      },
                      "BannerElement": {
                        "fields": {
                          "style": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.BannerElement.BannerStyle",
                            "id": 1,
                            "rule": "optional"
                          },
                          "text": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "isDismissible": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          },
                          "actions": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.BannerElement.Action",
                            "id": 4,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "BannerStyle": {
                            "values": {
                              "INFO": 0,
                              "SUCCESS": 1,
                              "WARNING": 2,
                              "CRITICAL": 3
                            }
                          },
                          "Action": {
                            "fields": {
                              "text": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "action": {
                                "type": ".squareup.bbfrontend.service.v1.PerformableAction",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "DividerElement": {
                        "fields": {
                          "margin": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.DividerElement.DividerMargin",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": "DIVIDER_MARGIN_EXTRA_SMALL"
                            }
                          },
                          "size": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.DividerElement.DividerSize",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": "DIVIDER_SIZE_LARGE"
                            }
                          }
                        },
                        "nested": {
                          "DividerMargin": {
                            "values": {
                              "DIVIDER_MARGIN_EXTRA_SMALL": 0,
                              "DIVIDER_MARGIN_SMALL": 1,
                              "DIVIDER_MARGIN_MEDIUM": 2,
                              "DIVIDER_MARGIN_LARGE": 3
                            }
                          },
                          "DividerSize": {
                            "values": {
                              "DIVIDER_SIZE_SMALL": 0,
                              "DIVIDER_SIZE_LARGE": 1
                            }
                          }
                        }
                      },
                      "ImageElement": {
                        "fields": {
                          "contentDescription": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "remoteImage": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.ImageElement.RemoteImage",
                            "id": 2
                          },
                          "localImage": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.ImageElement.LocalImage",
                            "id": 3
                          }
                        },
                        "nested": {
                          "LocalImage": {
                            "values": {
                              "DO_NOT_USE_LOCAL_IMAGE": 0
                            }
                          },
                          "RemoteImage": {
                            "fields": {
                              "url": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "aspectRatio": {
                                "type": "double",
                                "id": 2,
                                "rule": "optional"
                              },
                              "maxHeight": {
                                "type": "double",
                                "id": 3
                              },
                              "maxWidth": {
                                "type": "double",
                                "id": 4
                              }
                            },
                            "nested": {
                              "constraint": {
                                "oneof": ["maxHeight", "maxWidth"]
                              }
                            }
                          },
                          "image": {
                            "oneof": ["remoteImage", "localImage"]
                          }
                        }
                      },
                      "AddressInputElement": {
                        "fields": {
                          "globalAddress": {
                            "type": ".squareup.common.location.GlobalAddress",
                            "id": 1,
                            "rule": "optional"
                          },
                          "isEnabled": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "errorFields": {
                            "type": ".squareup.bbfrontend.common.component.AddressInputDescription.ErrorFieldType",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CardElement": {
                        "fields": {
                          "front": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement.Front",
                            "id": 1,
                            "rule": "optional"
                          },
                          "back": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement.Back",
                            "id": 2,
                            "rule": "optional"
                          },
                          "isLocked": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        },
                        "nested": {
                          "Front": {
                            "fields": {
                              "bodyImage": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement.Body",
                                "id": 1,
                                "rule": "optional"
                              },
                              "bottomRight": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement.Front.BottomRight",
                                "id": 2,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "BottomRight": {
                                "fields": {
                                  "pan": {
                                    "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement.Pan",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "customization": {
                                    "type": ".squareup.bbfrontend.common.component.CardCustomization",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "businessName": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          },
                          "Back": {
                            "fields": {
                              "bodyImage": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement.Body",
                                "id": 1,
                                "rule": "optional"
                              },
                              "pan": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement.Pan",
                                "id": 2,
                                "rule": "optional"
                              },
                              "expiration": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "securityCode": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "name": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              },
                              "copyPanAction": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement.Back.CopyAction",
                                "id": 6,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "CopyAction": {
                                "fields": {
                                  "text": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "value": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "logEvent": {
                                    "type": ".squareup.bbfrontend.service.v1.LogEvent",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "copiedMessage": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          },
                          "Pan": {
                            "fields": {
                              "components": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement.Pan.Component",
                                "id": 1,
                                "rule": "repeated"
                              },
                              "accessibilityLabel": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "Component": {
                                "fields": {
                                  "obscured": {
                                    "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement.Pan.Component.Obscured",
                                    "id": 1
                                  },
                                  "visible": {
                                    "type": "string",
                                    "id": 2
                                  }
                                },
                                "nested": {
                                  "Obscured": {
                                    "fields": {
                                      "count": {
                                        "type": "int32",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "character": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "display": {
                                    "oneof": ["obscured", "visible"]
                                  }
                                }
                              }
                            }
                          },
                          "Body": {
                            "fields": {
                              "productType": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement.Body.ProductType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "bodyVariation": {
                                "type": ".squareup.bbfrontend.service.v1.UiElement.CardElement.Body.BodyVariation",
                                "id": 2,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "ProductType": {
                                "values": {
                                  "DO_NOT_USE": 0,
                                  "DEBIT": 1,
                                  "CREDIT": 2
                                }
                              },
                              "BodyVariation": {
                                "values": {
                                  "DO_NOT_USE_BODY_VARIATION": 0,
                                  "BODY_VARIATION_DEBIT_US": 1,
                                  "BODY_VARIATION_CREDIT": 2,
                                  "BODY_VARIATION_DEBIT_CA": 3,
                                  "BODY_VARIATION_DEBIT_UK": 4
                                }
                              }
                            }
                          }
                        }
                      },
                      "PillElement": {
                        "fields": {
                          "text": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "icon": {
                            "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                            "id": 2,
                            "rule": "optional"
                          },
                          "size": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.PillElement.PillSize",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": "PILL_SIZE_NORMAL"
                            }
                          },
                          "variant": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.PillElement.PillVariant",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": "PILL_VARIANT_NORMAL"
                            }
                          },
                          "alignment": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.PillElement.PillAlignment",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": "PILL_ALIGNMENT_CENTER"
                            }
                          }
                        },
                        "nested": {
                          "PillSize": {
                            "values": {
                              "PILL_SIZE_NORMAL": 0,
                              "PILL_SIZE_COMPACT": 1
                            }
                          },
                          "PillVariant": {
                            "values": {
                              "PILL_VARIANT_NORMAL": 0,
                              "PILL_VARIANT_EMPHASIS": 1,
                              "PILL_VARIANT_SUCCESS": 2,
                              "PILL_VARIANT_WARNING": 3,
                              "PILL_VARIANT_CRITICAL": 4,
                              "PILL_VARIANT_ALPHA": 6,
                              "PILL_VARIANT_BETA": 7
                            }
                          },
                          "PillAlignment": {
                            "values": {
                              "PILL_ALIGNMENT_CENTER": 0,
                              "PILL_ALIGNMENT_LEADING": 1
                            }
                          }
                        }
                      },
                      "MoneyInputElement": {
                        "fields": {
                          "label": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "placeholderAmount": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "amount": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "maximumAmount": {
                            "type": ".squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "helperMessage": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.MoneyInputElement.HelperMessage",
                            "id": 5,
                            "rule": "optional"
                          },
                          "isEditable": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          }
                        },
                        "nested": {
                          "HelperMessage": {
                            "fields": {
                              "hint": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "error": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "TextLinkElement": {
                        "fields": {
                          "text": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "size": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.TextLinkElement.TextLinkSize",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": "TEXT_LINK_SIZE_MEDIUM"
                            }
                          },
                          "isEnabled": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "action": {
                            "type": ".squareup.bbfrontend.service.v1.PerformableAction",
                            "id": 4,
                            "rule": "optional"
                          },
                          "actionLogEvent": {
                            "type": ".squareup.bbfrontend.service.v1.LogEvent",
                            "id": 5,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "TextLinkSize": {
                            "values": {
                              "TEXT_LINK_SIZE_SMALL": 0,
                              "TEXT_LINK_SIZE_MEDIUM": 1
                            }
                          }
                        }
                      },
                      "element": {
                        "oneof": ["buttonElement", "textElement", "textInputElement", "loadingElement", "spacingElement", "rowElement", "debitCardElement", "bannerElement", "dividerElement", "imageElement", "addressInputElement", "cardElement", "pillElement", "moneyInputElement", "sectionHeaderElement", "textLinkElement"]
                      }
                    }
                  },
                  "PerformableAction": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "logEvent": {
                        "type": ".squareup.bbfrontend.service.v1.LogEvent",
                        "id": 5,
                        "rule": "optional"
                      },
                      "submission": {
                        "type": ".squareup.bbfrontend.service.v1.PerformableAction.Submission",
                        "id": 2
                      },
                      "url": {
                        "type": ".squareup.bbfrontend.common.component.WebURL",
                        "id": 3
                      },
                      "flow": {
                        "type": ".squareup.bbfrontend.service.v1.PerformableAction.BBFrontendFlow",
                        "id": 4
                      },
                      "addCardToDigitalWallet": {
                        "type": ".squareup.bbfrontend.service.v1.PerformableAction.AddCardToDigitalWallet",
                        "id": 6
                      }
                    },
                    "nested": {
                      "Submission": {
                        "fields": {
                          "loadingElement": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.LoadingElement",
                            "id": 1,
                            "rule": "optional"
                          },
                          "isSelected": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      },
                      "BBFrontendFlow": {
                        "fields": {
                          "flow": {
                            "type": ".squareup.bbfrontend.service.v1.Flow",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "AddCardToDigitalWallet": {
                        "fields": {
                          "configuration": {
                            "type": ".squareup.bbfrontend.service.v1.DigitalWalletConfiguration",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "action": {
                        "oneof": ["submission", "url", "flow", "addCardToDigitalWallet"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.ButtonElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.ButtonElement?.nested?.SubmissionAction && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.ButtonElement?.nested?.CompletionAction && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.ButtonElement?.nested?.CompletionAction?.nested?.Result && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.ButtonElement?.nested?.UrlAction && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.ButtonElement?.nested?.TargetFlow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.ButtonElement?.nested?.Style && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.TextElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.TextStyle && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.TextColor && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.TextAlignment && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.TextInputElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.TextInputElement?.nested?.HelperMessage && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.TextInputElement?.nested?.TextValidation && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.TextInputElement?.nested?.TextValidation?.nested?.Template && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.TextInputElement?.nested?.KeyboardType && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.LoadingElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.LoadingElement?.nested?.ActivityIndicatorSize && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.SpacingElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.SpacingElement?.nested?.Size && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.RowElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.RowElement?.nested?.TextContent && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.RowElement?.nested?.TextContent?.nested?.Standard && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.RowElement?.nested?.TextContent?.nested?.Standard?.nested?.StyleOverrides && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.RowElement?.nested?.TextContent?.nested?.Standard?.nested?.StyleOverrides?.nested?.Override && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.RowElement?.nested?.TextContent?.nested?.Custom && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.RowElement?.nested?.AccessoryAlignment && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.RowElement?.nested?.LeadingAccessory && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.RowElement?.nested?.TrailingAccessory && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.RowElement?.nested?.RowStyle && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.RowElement?.nested?.TextLinkTrailingAccessory && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.SectionHeaderElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.SectionHeaderElement?.nested?.Style && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.DebitCardElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.DebitCardElement?.nested?.CardFront && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.DebitCardElement?.nested?.CardBack && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.DebitCardElement?.nested?.CardBack?.nested?.ObscuredCardData && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.DebitCardElement?.nested?.CardBack?.nested?.PrivateCardData && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.BannerElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.BannerElement?.nested?.BannerStyle && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.BannerElement?.nested?.Action && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.DividerElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.DividerElement?.nested?.DividerMargin && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.DividerElement?.nested?.DividerSize && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.ImageElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.ImageElement?.nested?.LocalImage && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.ImageElement?.nested?.RemoteImage && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.AddressInputElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.CardElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.CardElement?.nested?.Front && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.CardElement?.nested?.Front?.nested?.BottomRight && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.CardElement?.nested?.Back && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.CardElement?.nested?.Back?.nested?.CopyAction && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.CardElement?.nested?.Pan && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.CardElement?.nested?.Pan?.nested?.Component && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.CardElement?.nested?.Pan?.nested?.Component?.nested?.Obscured && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.CardElement?.nested?.Body && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.CardElement?.nested?.Body?.nested?.ProductType && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.CardElement?.nested?.Body?.nested?.BodyVariation && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.PillElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.PillElement?.nested?.PillSize && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.PillElement?.nested?.PillVariant && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.PillElement?.nested?.PillAlignment && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.MoneyInputElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.MoneyInputElement?.nested?.HelperMessage && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.TextLinkElement && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UiElement?.nested?.TextLinkElement?.nested?.TextLinkSize && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.PerformableAction && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.PerformableAction?.nested?.Submission && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.PerformableAction?.nested?.BBFrontendFlow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.PerformableAction?.nested?.AddCardToDigitalWallet) {
  $root.addJSON(jsonData);
}

/**
 * Represents ui elements that the clients will transform from data into renderable UI.
 *
 * SOURCE UiElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 25:1
 */
export const UiElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement');
fixType(UiElement, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement);
/**
 * SOURCE ButtonElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 52:3
 */
UiElement.ButtonElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.ButtonElement');
fixType(UiElement.ButtonElement, {
  buttonText: {
    notEmpty: true
  },
  style: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.ButtonElement);
/**
 * Describes an action that on client press will submit the form back to
 * onyx server. The button that is pressed will be flagged as selected so that
 * the server knows which button was pressed and how to respond. On the client
 * the loading element can be used to configure the loading screen shown.
 *
 * SOURCE SubmissionAction @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 73:5
 */
UiElement.ButtonElement.SubmissionAction = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.ButtonElement.SubmissionAction');
fixType(UiElement.ButtonElement.SubmissionAction, {
  id: {
    notEmpty: true
  },
  loadingElement: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.ButtonElement.SubmissionAction);
/**
 * Describes an action that on client press will close the current presented
 * flow. The action holds a result to let the client know how the flow
 * completed.
 *
 * SOURCE CompletionAction @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 84:5
 */
UiElement.ButtonElement.CompletionAction = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.ButtonElement.CompletionAction');
fixType(UiElement.ButtonElement.CompletionAction, {
  id: {
    notEmpty: true
  },
  result: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.ButtonElement.CompletionAction);
/**
 * SOURCE Result @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 88:7
 */
UiElement.ButtonElement.CompletionAction.Result = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.ButtonElement.CompletionAction.Result').values;
/**
 * Describes an action that on client press will open the given URL. It is optional for
 * the client to open the URL with session bridge.
 *
 * SOURCE UrlAction @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 101:5
 */
UiElement.ButtonElement.UrlAction = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.ButtonElement.UrlAction');
fixType(UiElement.ButtonElement.UrlAction, {
  id: {
    notEmpty: true
  },
  urlString: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.ButtonElement.UrlAction);
/**
 * Describes a specific flow the client is expected to present.
 *
 * SOURCE TargetFlow @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 110:5
 */
UiElement.ButtonElement.TargetFlow = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.ButtonElement.TargetFlow');
fixType(UiElement.ButtonElement.TargetFlow);
Builder.createAndAttachToType(UiElement.ButtonElement.TargetFlow);
/**
 * SOURCE Style @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 116:5
 */
UiElement.ButtonElement.Style = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.ButtonElement.Style').values;
/**
 * Simple text message - no input, just text to display. *
 *
 * SOURCE TextElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 125:3
 */
UiElement.TextElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.TextElement');
fixType(UiElement.TextElement, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.TextElement);
/**
 * SOURCE TextStyle @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 132:3
 */
UiElement.TextStyle = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.TextStyle').values;
/**
 * SOURCE TextColor @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 148:3
 */
UiElement.TextColor = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.TextColor').values;
/**
 * SOURCE TextAlignment @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 159:3
 */
UiElement.TextAlignment = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.TextAlignment').values;
/**
 * This is an input field element to collect data from the user.
 *
 * SOURCE TextInputElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 167:3
 */
UiElement.TextInputElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.TextInputElement');
fixType(UiElement.TextInputElement, {
  label: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.TextInputElement);
/**
 * SOURCE HelperMessage @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 197:5
 */
UiElement.TextInputElement.HelperMessage = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.TextInputElement.HelperMessage');
fixType(UiElement.TextInputElement.HelperMessage);
Builder.createAndAttachToType(UiElement.TextInputElement.HelperMessage);
/**
 * SOURCE TextValidation @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 219:5
 */
UiElement.TextInputElement.TextValidation = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.TextInputElement.TextValidation');
fixType(UiElement.TextInputElement.TextValidation, {
  regex: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.TextInputElement.TextValidation);
/**
 * SOURCE Template @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 229:7
 */
UiElement.TextInputElement.TextValidation.Template = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.TextInputElement.TextValidation.Template');
fixType(UiElement.TextInputElement.TextValidation.Template, {
  template: {
    notEmpty: true
  },
  templatePlaceholderCharacter: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.TextInputElement.TextValidation.Template);
/**
 * SOURCE KeyboardType @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 244:5
 */
UiElement.TextInputElement.KeyboardType = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.TextInputElement.KeyboardType').values;
/**
 * Loading element that displays a spinner horizontally centered.
 * Title and message below the spinner are optional.
 *
 * SOURCE LoadingElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 263:3
 */
UiElement.LoadingElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.LoadingElement');
fixType(UiElement.LoadingElement);
Builder.createAndAttachToType(UiElement.LoadingElement);
/**
 * SOURCE ActivityIndicatorSize @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 268:5
 */
UiElement.LoadingElement.ActivityIndicatorSize = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.LoadingElement.ActivityIndicatorSize').values;
/**
 * Element that adds space between elements. These spacings correspond to
 * Market tokens with predefined values for each client. The values are based on a
 * base-100 system where SPACING_25 is 1/4 scale of SPACING_100, and SPACING_200
 * is twice the size of SPACING_100, etc.
 *
 * SPACING_100 is considered the primary spacing size.
 *
 * SOURCE SpacingElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 283:3
 */
UiElement.SpacingElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.SpacingElement');
fixType(UiElement.SpacingElement);
Builder.createAndAttachToType(UiElement.SpacingElement);
/**
 * SOURCE Size @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 286:5
 */
UiElement.SpacingElement.Size = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.SpacingElement.Size').values;
/**
 * Element that represents a Market Row.
 * ┌───────────────────────────────────────────────────────────────┐
 * │ ┌────┐ ┌───────────────────────────────┐ ┌──────────────────┐ │
 * │ │icon│ │          text_content         │ │trailing_accessory│ │
 * │ └────┘ └───────────────────────────────┘ └──────────────────┘ │
 * └───────────────────────────────────────────────────────────────┘
 * If no icon is set, then the text_content is shifted to the leading edge.
 * ┌───────────────────────────────────────────────────────────────┐
 * │ ┌──────────────────────────────────────┐ ┌──────────────────┐ │
 * │ │              text_content            │ │trailing_accessory│ │
 * │ └──────────────────────────────────────┘ └──────────────────┘ │
 * └───────────────────────────────────────────────────────────────┘
 * If trailing_accessory is not set, the text_content is expanded to trailing edge.
 * ┌───────────────────────────────────────────────────────────────┐
 * │ ┌────┐ ┌────────────────────────────────────────────────────┐ │
 * │ │icon│ │                     text_content                   │ │
 * │ └────┘ └────────────────────────────────────────────────────┘ │
 * └───────────────────────────────────────────────────────────────┘
 *
 * SOURCE RowElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 318:3
 */
UiElement.RowElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.RowElement');
fixType(UiElement.RowElement, {
  textContent: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.RowElement);
/**
 * SOURCE TextContent @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 380:5
 */
UiElement.RowElement.TextContent = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.RowElement.TextContent');
fixType(UiElement.RowElement.TextContent);
Builder.createAndAttachToType(UiElement.RowElement.TextContent);
/**
 * Standard TextContent rows will be rendered using the default MarketRow.TextContent
 * and standard MarketStyleSheet.
 * ┌───────────────────────────────────────────┐
 * │ title                            sideText │
 * │                                           │
 * │ secondaryText           secondarySideText │
 * └───────────────────────────────────────────┘
 *
 * Use StyleOverrides to change the default fonts or colors from the row style.
 *
 * SOURCE Standard @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 397:7
 */
UiElement.RowElement.TextContent.Standard = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.RowElement.TextContent.Standard');
fixType(UiElement.RowElement.TextContent.Standard, {
  title: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.RowElement.TextContent.Standard);
/**
 * SOURCE StyleOverrides @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 404:9
 */
UiElement.RowElement.TextContent.Standard.StyleOverrides = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.RowElement.TextContent.Standard.StyleOverrides');
fixType(UiElement.RowElement.TextContent.Standard.StyleOverrides);
Builder.createAndAttachToType(UiElement.RowElement.TextContent.Standard.StyleOverrides);
/**
 * SOURCE Override @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 410:11
 */
UiElement.RowElement.TextContent.Standard.StyleOverrides.Override = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.RowElement.TextContent.Standard.StyleOverrides.Override');
fixType(UiElement.RowElement.TextContent.Standard.StyleOverrides.Override);
Builder.createAndAttachToType(UiElement.RowElement.TextContent.Standard.StyleOverrides.Override);
/**
 * Custom TextContent rows allow custom rendering of text in the row. It allows custom
 * implementation of `TextStyle` and any number of stackable `TextElements`.
 *
 * With great power comes great responsibility; in almost all cases, the standard row
 * TextContent should be used. Custom should only be used when design has a strong use case
 * for a one off row.
 * ┌─────────────────────────────────────────────────────┐
 * │ ┌───────────────────┐       ┌─────────────────────┐ │
 * │ │primary_content    │       │    secondary_content│ │
 * │ │1                  │       │                    1│ │
 * │ │2                  │       │                    2│ │
 * │ │...                │       │                  ...│ │
 * │ └───────────────────┘       └─────────────────────┘ │
 * └─────────────────────────────────────────────────────┘
 *
 * SOURCE Custom @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 433:7
 */
UiElement.RowElement.TextContent.Custom = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.RowElement.TextContent.Custom');
fixType(UiElement.RowElement.TextContent.Custom, {
  primaryContent: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.RowElement.TextContent.Custom);
/**
 * SOURCE AccessoryAlignment @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 439:5
 */
UiElement.RowElement.AccessoryAlignment = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.RowElement.AccessoryAlignment').values;
/**
 * SOURCE LeadingAccessory @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 446:5
 */
UiElement.RowElement.LeadingAccessory = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.RowElement.LeadingAccessory').values;
/**
 * SOURCE TrailingAccessory @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 453:5
 */
UiElement.RowElement.TrailingAccessory = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.RowElement.TrailingAccessory').values;
/**
 * SOURCE RowStyle @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 462:5
 */
UiElement.RowElement.RowStyle = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.RowElement.RowStyle').values;
/**
 * SOURCE TextLinkTrailingAccessory @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 467:5
 */
UiElement.RowElement.TextLinkTrailingAccessory = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.RowElement.TextLinkTrailingAccessory');
fixType(UiElement.RowElement.TextLinkTrailingAccessory, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.RowElement.TextLinkTrailingAccessory);
/**
 * SOURCE SectionHeaderElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 472:3
 */
UiElement.SectionHeaderElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.SectionHeaderElement');
fixType(UiElement.SectionHeaderElement, {
  style: {
    required: true
  },
  title: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.SectionHeaderElement);
/**
 * SOURCE Style @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 493:5
 */
UiElement.SectionHeaderElement.Style = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.SectionHeaderElement.Style').values;
/**
 * SOURCE DebitCardElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 501:3
 */
UiElement.DebitCardElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.DebitCardElement');
fixType(UiElement.DebitCardElement);
Builder.createAndAttachToType(UiElement.DebitCardElement);
/**
 * SOURCE CardFront @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 513:5
 */
UiElement.DebitCardElement.CardFront = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.DebitCardElement.CardFront');
fixType(UiElement.DebitCardElement.CardFront);
Builder.createAndAttachToType(UiElement.DebitCardElement.CardFront);
/**
 * SOURCE CardBack @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 520:5
 */
UiElement.DebitCardElement.CardBack = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.DebitCardElement.CardBack');
fixType(UiElement.DebitCardElement.CardBack, {
  fullName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.DebitCardElement.CardBack);
/**
 * SOURCE ObscuredCardData @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 528:7
 */
UiElement.DebitCardElement.CardBack.ObscuredCardData = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.DebitCardElement.CardBack.ObscuredCardData');
fixType(UiElement.DebitCardElement.CardBack.ObscuredCardData, {
  panLastFour: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.DebitCardElement.CardBack.ObscuredCardData);
/**
 * SOURCE PrivateCardData @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 532:7
 */
UiElement.DebitCardElement.CardBack.PrivateCardData = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.DebitCardElement.CardBack.PrivateCardData');
fixType(UiElement.DebitCardElement.CardBack.PrivateCardData, {
  pan: {
    notEmpty: true
  },
  expiration: {
    notEmpty: true
  },
  securityCode: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.DebitCardElement.CardBack.PrivateCardData);
/**
 * Used to show a banner at the top of the screen. Banners are usually short messages that can
 * always persist. They can be dismissible.
 *
 * SOURCE BannerElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 544:3
 */
UiElement.BannerElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.BannerElement');
fixType(UiElement.BannerElement, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.BannerElement);
/**
 * SOURCE BannerStyle @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 550:5
 */
UiElement.BannerElement.BannerStyle = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.BannerElement.BannerStyle').values;
/**
 * SOURCE Action @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 558:5
 */
UiElement.BannerElement.Action = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.BannerElement.Action');
fixType(UiElement.BannerElement.Action, {
  text: {
    notEmpty: true
  },
  action: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.BannerElement.Action);
/**
 * Divider used to separate discrete chunks of content
 *
 * SOURCE DividerElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 565:3
 */
UiElement.DividerElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.DividerElement');
fixType(UiElement.DividerElement);
Builder.createAndAttachToType(UiElement.DividerElement);
/**
 * SOURCE DividerMargin @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 569:5
 */
UiElement.DividerElement.DividerMargin = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.DividerElement.DividerMargin').values;
/**
 * SOURCE DividerSize @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 576:5
 */
UiElement.DividerElement.DividerSize = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.DividerElement.DividerSize').values;
/**
 * Represents image element to be rendered on the screen.
 * There's an option of showing a LocalImage or a RemoteImage.
 *
 * SOURCE ImageElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 586:3
 */
UiElement.ImageElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.ImageElement');
fixType(UiElement.ImageElement);
Builder.createAndAttachToType(UiElement.ImageElement);
/**
 * Images that clients have bundled.
 *
 * SOURCE LocalImage @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 597:5
 */
UiElement.ImageElement.LocalImage = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.ImageElement.LocalImage').values;
/**
 * Images that are hosted
 *
 * SOURCE RemoteImage @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 604:5
 */
UiElement.ImageElement.RemoteImage = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.ImageElement.RemoteImage');
fixType(UiElement.ImageElement.RemoteImage, {
  url: {
    notEmpty: true
  },
  aspectRatio: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.ImageElement.RemoteImage);
/**
 * An input field element to view or to input/edit (if enabled) addresses.
 *
 * SOURCE AddressInputElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 628:3
 */
UiElement.AddressInputElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.AddressInputElement');
fixType(UiElement.AddressInputElement);
Builder.createAndAttachToType(UiElement.AddressInputElement);
/**
 * SOURCE CardElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 636:3
 */
UiElement.CardElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.CardElement');
fixType(UiElement.CardElement, {
  front: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.CardElement);
/**
 * SOURCE Front @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 641:5
 */
UiElement.CardElement.Front = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.CardElement.Front');
fixType(UiElement.CardElement.Front, {
  bodyImage: {
    required: true
  },
  bottomRight: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.CardElement.Front);
/**
 * SOURCE BottomRight @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 646:7
 */
UiElement.CardElement.Front.BottomRight = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.CardElement.Front.BottomRight');
fixType(UiElement.CardElement.Front.BottomRight);
Builder.createAndAttachToType(UiElement.CardElement.Front.BottomRight);
/**
 * SOURCE Back @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 653:5
 */
UiElement.CardElement.Back = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.CardElement.Back');
fixType(UiElement.CardElement.Back, {
  bodyImage: {
    required: true
  },
  pan: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.CardElement.Back);
/**
 * Represents the action and visible button to display on the card to copy the card's pan.
 *
 * SOURCE CopyAction @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 667:7
 */
UiElement.CardElement.Back.CopyAction = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.CardElement.Back.CopyAction');
fixType(UiElement.CardElement.Back.CopyAction, {
  text: {
    notEmpty: true
  },
  value: {
    notEmpty: true
  },
  copiedMessage: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.CardElement.Back.CopyAction);
/**
 * SOURCE Pan @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 679:5
 */
UiElement.CardElement.Pan = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.CardElement.Pan');
fixType(UiElement.CardElement.Pan, {
  components: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.CardElement.Pan);
/**
 * Represents one part of a pan.
 * For example, "****  ******  60123" is three components.
 *
 * SOURCE Component @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 688:7
 */
UiElement.CardElement.Pan.Component = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.CardElement.Pan.Component');
fixType(UiElement.CardElement.Pan.Component);
Builder.createAndAttachToType(UiElement.CardElement.Pan.Component);
/**
 * Hidden from the user for security. Typically represented like "****".
 *
 * SOURCE Obscured @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 695:9
 */
UiElement.CardElement.Pan.Component.Obscured = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.CardElement.Pan.Component.Obscured');
fixType(UiElement.CardElement.Pan.Component.Obscured, {
  count: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.CardElement.Pan.Component.Obscured);
/**
 * SOURCE Body @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 704:5
 */
UiElement.CardElement.Body = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.CardElement.Body');
fixType(UiElement.CardElement.Body, {
  productType: {
    required: true
  },
  bodyVariation: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.CardElement.Body);
/**
 * SOURCE ProductType @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 713:7
 */
UiElement.CardElement.Body.ProductType = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.CardElement.Body.ProductType').values;
/**
 * Represents a specific card body to render.
 *
 * SOURCE BodyVariation @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 722:7
 */
UiElement.CardElement.Body.BodyVariation = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.CardElement.Body.BodyVariation').values;
/**
 * Text and icon displayed in a pill-shaped view. *
 *
 * SOURCE PillElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 733:3
 */
UiElement.PillElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.PillElement');
fixType(UiElement.PillElement, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.PillElement);
/**
 * SOURCE PillSize @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 740:5
 */
UiElement.PillElement.PillSize = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.PillElement.PillSize').values;
/**
 * SOURCE PillVariant @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 745:5
 */
UiElement.PillElement.PillVariant = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.PillElement.PillVariant').values;
/**
 * When the pill is displayed by itself, how to align horizontally. *
 *
 * SOURCE PillAlignment @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 757:5
 */
UiElement.PillElement.PillAlignment = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.PillElement.PillAlignment').values;
/**
 * Input to collect a Money value.
 *
 * SOURCE MoneyInputElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 764:3
 */
UiElement.MoneyInputElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.MoneyInputElement');
fixType(UiElement.MoneyInputElement, {
  label: {
    notEmpty: true
  },
  amount: {
    required: true
  }
});
Builder.createAndAttachToType(UiElement.MoneyInputElement);
/**
 * SOURCE HelperMessage @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 804:5
 */
UiElement.MoneyInputElement.HelperMessage = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.MoneyInputElement.HelperMessage');
fixType(UiElement.MoneyInputElement.HelperMessage);
Builder.createAndAttachToType(UiElement.MoneyInputElement.HelperMessage);
/**
 * A tappable text label. *
 *
 * SOURCE TextLinkElement @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 818:3
 */
UiElement.TextLinkElement = $root.lookupType('squareup.bbfrontend.service.v1.UiElement.TextLinkElement');
fixType(UiElement.TextLinkElement, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UiElement.TextLinkElement);
/**
 * SOURCE TextLinkSize @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 834:5
 */
UiElement.TextLinkElement.TextLinkSize = $root.lookupEnum('squareup.bbfrontend.service.v1.UiElement.TextLinkElement.TextLinkSize').values;
/**
 * SOURCE PerformableAction @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 841:1
 */
export const PerformableAction = $root.lookupType('squareup.bbfrontend.service.v1.PerformableAction');
fixType(PerformableAction, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PerformableAction);
/**
 * Describes an action that on client press will submit the form back to
 * onyx server. The element that is pressed should be flagged as selected so that
 * the server knows what was pressed and how to respond.
 *
 * SOURCE Submission @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 858:3
 */
PerformableAction.Submission = $root.lookupType('squareup.bbfrontend.service.v1.PerformableAction.Submission');
fixType(PerformableAction.Submission);
Builder.createAndAttachToType(PerformableAction.Submission);
/**
 * Describes an action that directs clients use bb-frontend's
 * BalancesWorkflowServiceV1.GetWorkflow for rendering an auxiliary screen.
 *
 * SOURCE BBFrontendFlow @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 867:3
 */
PerformableAction.BBFrontendFlow = $root.lookupType('squareup.bbfrontend.service.v1.PerformableAction.BBFrontendFlow');
fixType(PerformableAction.BBFrontendFlow, {
  flow: {
    required: true
  }
});
Builder.createAndAttachToType(PerformableAction.BBFrontendFlow);
/**
 * Describes an action that directs clients use present the flow
 * to add a card to the device's digital wallet.
 *
 * SOURCE AddCardToDigitalWallet @ squareup/bbfrontend/common/workflow/ui_elements/ui_element.proto at 875:3
 */
PerformableAction.AddCardToDigitalWallet = $root.lookupType('squareup.bbfrontend.service.v1.PerformableAction.AddCardToDigitalWallet');
fixType(PerformableAction.AddCardToDigitalWallet, {
  configuration: {
    required: true
  }
});
Builder.createAndAttachToType(PerformableAction.AddCardToDigitalWallet);